module.exports = __webpack_public_path__ + "static/media/gryphon_musee_urbanlandscape_5.68b1b715.jpg";